import { IDirective } from 'angular';
import { ModalService } from '../../../components/modals/gmc-modal/gmc-modal.service';
import { StateService } from '@uirouter/angularjs';
import './buttons.scss';

export function buttonDisabled(modalSerivce: ModalService, $state: StateService): IDirective {
  return {
    restrict: 'A',
    scope: {
      color: '@color',
      case: '=case',
      modalMessage: '@modalMessage',
      modalType: '@modalType',
      redirect: '@redirect'
    },
    replace: true,
    link: ($scope: any, $element, $attr) => {
      $scope.$watch('case', () => {
        console.log($scope.case);
        if ($scope.case && $scope.modalMessage) {
          let data;
          switch ($scope.modalType) {
            case 'additionalInfoModal': {
              data = {
                text: $scope.modalMessage,
                acceptBtnText: 'Activate it now',
                rejectBtnText: 'Cancel'
              };
              break;
            }
            case 'infoModal': {
              data = {
                buttonText: 'Ok',
                text: $scope.modalMessage
              };
              break;
            }
          }
          if ($element.hasClass(`btn-${$scope.color}`)) {
            $element.removeClass(`btn-${$scope.color}`);
          }
          $element.addClass(`btn-${$scope.color}-outline`);
          $element.prop('ng-click', null).off('click');
          $element.on('click', async () => {
            const modal = await modalSerivce.showModal({
              component: $scope.modalType,
              extraClasses: 'modal-dialog-centered-1',
              data
            });
            await modal.close;
            modal.closed.then((res) => {
              if (res && $scope.redirect) {
                $state.go($scope.redirect);
              }
            });
          });
          return;
        } else if ($scope.case) {
          $attr.$set('disabled', true);
          if ($element.hasClass(`btn-${$scope.color}`)) {
            $element.removeClass(`btn-${$scope.color}`);
          }
          console.log($scope.case);
          $element.addClass(`btn-${$scope.color}-outline`);
          return;
        } else {
          if ($element.hasClass(`btn-${$scope.color}-outline`)) {
            $element.removeClass(`btn-${$scope.color}-outline`);
          }
          $element.addClass(`btn-${$scope.color}`);
          $attr.$set('disabled', false);
        }
      });
    }
  };
}

buttonDisabled.$inject = [
  'ModalService',
  '$state'
];



// WEBPACK FOOTER //
// ./app/shared/directives/gmc-button-disable/gmc-button-disable.directive.ts